import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";

const GlobalStyle = createGlobalStyle`
  @import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSansNeo.css);
  ${normalize}
  html {
    max-width: 100%;
    overflow-x: hidden;
    font-size: 62.5%;
    background: black;
    
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, textarea, p, blockquote, th, td, input, select, textarea, button {
    margin: 0;
    padding: 0
  }

  body {
    max-width: 100%;
    position: relative;
    line-height: 100%;
    min-height: 100vh;
    font-family: "Manrope", sans-serif;
    color: #1C1C1E;
    background: black;

  }
  
  

  .swiper-pagination-bullet {
    background: #ffff !important;
    width: 4px !important;
    height: 4px !important;
  }

  fieldset, img {
    border: 0 none
  }

  
  
  
  dl, ul, ol, menu, li {
    list-style: none
  }

  blockquote, q {
    quotes: none
  }

  blockquote:before, blockquote:after, q:before, q:after {
    content: '';
    content: none
  }

  .vsc-controller {
    display: none;
  }
  
  input, select, textarea, button {
    font-size: 100%;
    vertical-align: middle;
  }

  button {
    border: 0 none;
    background-color: transparent;
    cursor: pointer
  }

  table {
    border-collapse: collapse;
    border-spacing: 0
  }

  input {
    border-radius: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  input[type='text'], input[type='password'], input[type='submit'], input[type='radio'], input[type='search'] {
    border-radius: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  input:checked[type='checkbox'] {
    background-color: #666;
    -webkit-appearance: checkbox
  }

  button, input[type='button'], input[type='submit'], input[type='reset'], input[type='file'] {
    -webkit-appearance: button;
    border-radius: 0
  }

  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none
  }

  body, th, td, input, select, textarea, button {
    font-size: 12px;
    line-height: 1.2;
    outline: 0;
    background-color: #fff
  }

  a {
    color: #4a4a4a;
    text-decoration: none;
    outline: 0
  }

  a:active, a:hover {
    text-decoration: none
  }

  address, caption, cite, code, dfn, em, var {
    font-style: normal;
    font-weight: normal
  }

  fieldset {
    min-width: 100%
  }

  img {
    vertical-align: top;
    cursor: pointer
  }

  textarea {
    resize: none;
  }

  textarea:focus, input:focus {
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  *:focus {
    outline: none
  }

  label {
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .swiper-button-prev:after, .swiper-button-next:after {
    font-size: 24px !important;
    color: white !important;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }

  #nprogress .bar {
    height: 3px !important;
  }


`;

export default GlobalStyle;
